export async function applyReceiptEndorsement(sale, receiptPrintPayload, saleEndorsement)
{
    if (saleEndorsement.isError)
        return;
    
    const endorsementReceipt = {};
    endorsementReceipt.header = `FBR Invoice Number: ${saleEndorsement.responseData.InvoiceNumber}`;
    endorsementReceipt.qrCode = `${saleEndorsement.responseData.InvoiceNumber}`;
    endorsementReceipt.footer = "Verify this invoice through FBR TaxAsaan Mobile App Or SMS at 9966 and win exciting prices in draw";

    receiptPrintPayload.endorsements.push(endorsementReceipt);
}

